export interface GlobalSearchResponse {
  data: {
    players: Array<{
      user_id: string;
      player_name: string;
      playerrank: number;
      isTop: boolean;
    }>;
    factions: Array<{
      faction_id: string;
      faction_name: string;
      factionrank: number;
      isTop: boolean;
    }>;
    events: Array<{
      eventId: string;
      searchKey: Array<string>;
    }>;
    superstars: Array<{
      wrestlerId: string;
      searchKey: Array<string>;
      ssImage: string;
    }>;
  };
}

export enum FeatureFlagEnum {
  'debug.settings' = 'debug.settings',
  'debug.sessionRecord' = 'debug.sessionRecord',
  'rbe' = 'rbe',
  'news' = 'news',
  'shop' = 'shop',
  'global' = 'global',
  'trivia' = 'trivia',
  'webshop' = 'webshop',
  'calendar' = 'calendar',
  'playGame' = 'playGame',
  'dashboard' = 'dashboard',
  'fanVoting' = 'fanVoting',
  'tournament' = 'tournament',
  'flashMarket' = 'flashMarket',
  'leaderboard' = 'leaderboard',
  'playerProfile' = 'playerProfile',
  'factionProfile' = 'factionProfile',
  'superStarGuide' = 'superStarGuide',
  'superStarGuide.1.1a' = 'superStarGuide.1.1a',
  'superStarGuide.1.1b' = 'superStarGuide.1.1b',
  'superStarGuide.offers' = 'superStarGuide.offers',
  'segmentation.p2' = 'segmentation.p2',
  'playgami' = 'playgami',
  'abTesting' = 'abTesting',
  'subscription' = 'subscription',
  'clubStore' = 'clubStore',
  'clubStore.offers' = 'clubStore.offers',
  'clubStore.offers.premium' = 'clubStore.offers.premium',
  'clubStore.offers.prestige' = 'clubStore.offers.prestige',
  'clubStore.offers.super_vip' = 'clubStore.offers.super_vip',
  'xsolla.paymentLiveMode' = 'xsolla.paymentLiveMode',
  'xsolla' = 'xsolla',
  'debug' = 'debug',
  'webShop' = 'webShop',
  'segmentation' = 'segmentation',
  'segmentation.offers' = 'segmentation.offers',
  'displayIAPOffers' = 'displayIAPOffers',
  'tutorial' = 'tutorial',
  'overhaul.leftSidebar' = 'overhaul.leftSidebar',
  'overhaul.tutorial' = 'overhaul.tutorial',
  'itemProbabilitiesDevControls' = 'itemProbabilitiesDevControls',
}

export type ConfigData = Record<FeatureFlagEnum, boolean>;

export interface ConfigResponse {
  data: ConfigData;
}

export type Flag = `${FeatureFlagEnum}` | FeatureFlagEnum;
